import { render } from "./Home.vue?vue&type=template&id=179000b6&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=179000b6&scoped=true&lang=css"

import exportComponent from "/dev/shm/repo/afsmc-website-ilna8d14el/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-179000b6"]])

export default __exports__